/* eslint-disable no-dupe-keys */
/* eslint-disable object-shorthand */
/* eslint-disable no-undef */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ReactLoading from "react-loading";
import PropTypes from "prop-types";

export default function ConfirmOrder({
  order_id1,
  order_code1,
  our_item1,
  ItemArray,
  id,
  photo,
  desc1,
  desc2,
  category1,
  ctn,
  qtytoctn,
  totoqty,
  utoprice,
  amount,
  cbm,
  ttocbm,
  nw,
  gw,
  status,
  notes,
}) {
  ConfirmOrder.propTypes = {
    order_id1: PropTypes.instanceOf(Array).isRequired,
    order_code1: PropTypes.instanceOf(Array).isRequired,
    our_item1: PropTypes.instanceOf(Array).isRequired,
    ItemArray: PropTypes.instanceOf(Array).isRequired,
    id: PropTypes.instanceOf(Array).isRequired,
    photo: PropTypes.instanceOf(Array).isRequired,
    desc1: PropTypes.instanceOf(Array).isRequired,
    desc2: PropTypes.instanceOf(Array).isRequired,
    category1: PropTypes.instanceOf(Array).isRequired,
    ctn: PropTypes.instanceOf(Array).isRequired,
    qtytoctn: PropTypes.instanceOf(Array).isRequired,
    totoqty: PropTypes.instanceOf(Array).isRequired,
    utoprice: PropTypes.instanceOf(Array).isRequired,
    amount: PropTypes.instanceOf(Array).isRequired,
    cbm: PropTypes.instanceOf(Array).isRequired,
    ttocbm: PropTypes.instanceOf(Array).isRequired,
    nw: PropTypes.instanceOf(Array).isRequired,
    gw: PropTypes.instanceOf(Array).isRequired,
    status: PropTypes.instanceOf(Array).isRequired,
    notes: PropTypes.instanceOf(Array).isRequired,
  };
  const [dialogsucesss, setOpen1] = React.useState(false);
  const [dialogempty, setOpen2] = React.useState(false);
  const [dialogloading, setOpen3] = React.useState(false);
  const handleClickOpenLoading = () => {
    setOpen3(true);
  };
  const handleCloseLoading = () => {
    setOpen3(false);
  };
  const { t } = useTranslation();

  const handleClickOpenSuccess = () => {
    setOpen1(true);
  };
  const handleClickOpenEmpty = () => {
    setOpen2(true);
  };

  const handleCloseSuccess = () => {
    setOpen1(false);
  };
  const handleCloseEmpty = () => {
    setOpen2(false);
  };
  function EditOrder() {
    const headers = { ContentType: `application/json` };
    const url = "https://trust-cargo.co/anas_backend/api/confirm_order";

    axios
      .post(
        url,
        {
          order_code: order_code1,
          order_id: order_id1,
          our_item: our_item1,
          photo: photo,
          description1: desc1,
          description2: desc2,
          category: category1,
          ctn: ctn,
          amount: amount,
          cbm: cbm,
          status: status,
          notes: notes,
          qty_ctn: qtytoctn,
          t_qty: totoqty,
          u_price: utoprice,
          t_cbm: ttocbm,
          n_w: nw,
          g_w: gw,
          notes: notes,
        },
        headers
      )
      .then((response) => {
        // console.log("success");
        // console.log(formData);
        handleCloseLoading();
        handleClickOpenSuccess();
      })
      .catch((error) => {
        console.log("error", error);
      });
  }
  const navigate = useNavigate();
  return (
    <div>
      <Button
        variant="contained"
        style={{ margin: "20px", color: "white" }}
        onClick={() => {
          handleClickOpenLoading();
          if (status.indexOf("new") > -1) {
            handleCloseLoading();
            handleClickOpenEmpty();
          } else {
            EditOrder();
          }
        }}
      >
        Confirm Order
      </Button>
      <Dialog
        open={dialogsucesss}
        onClose={handleCloseSuccess}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Orders confirmed successfully</DialogTitle>
        <DialogContent>
          {/* <DialogContentText id="alert-dialog-description">
            Let Google help apps determine location. This means sending anonymous location data to
            Google, even when no apps are running.
          </DialogContentText> */}
        </DialogContent>
        <DialogActions>
          {/* navigate("/add_user"); */}
          {/* <Button onClick={handleClose}>ok</Button> */}
          <Button
            onClick={() => {
              navigate("/customers");
            }}
            autoFocus
          >
            {t("ok")}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={dialogempty}
        onClose={handleCloseEmpty}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Some orders have received or confirmed status
        </DialogTitle>
        <DialogContent>
          {/* <DialogContentText id="alert-dialog-description">
            Let Google help apps determine location. This means sending anonymous location data to
            Google, even when no apps are running.
          </DialogContentText> */}
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleClose}>ok</Button> */}
          <Button onClick={handleCloseEmpty} autoFocus>
            {t("ok!!")}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={dialogloading}
        onClose={handleCloseLoading}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <ReactLoading color="blue" height={50} width={50} type="spokes" />
      </Dialog>
    </div>
  );
}
